(function () {
  'use strict';

  function track(instance, eventName, data) {
    if (typeof fbq === 'function') {
      if (data && data._fbStandard) {
        const { _fbStandard, _fbEventId, _gaEvent, ...fbData } = data;
        const opts = _fbEventId ? { eventID: _fbEventId } : {};
        fbq('track', _fbStandard, fbData, opts);
      } else {
        fbq('trackCustom', eventName, data || {});
      }
    }

    if (typeof gtag === 'function') {
      const gaEvent = data && data._gaEvent || eventName;
      const { _fbStandard, _fbEventId, _gaEvent: _, ...gaData } = data || {};
      gtag('event', gaEvent, gaData);
    }
  }

  function identifyKlaviyo(instance, email, subscribe) {
    const _learnq = window._learnq || [];
    const firstTurn = instance.conversationHistory[0] || {};
    const anchorAnswer = firstTurn.selected_value || firstTurn.answer || '';

    _learnq.push(['identify', {
      '$email': email,
      'Tara Hair Consultation - Primary Concern': anchorAnswer,
      'Tara Hair Consultation - Completed': true,
      'Tara Hair Consultation - Date': new Date().toISOString()
    }]);

    _learnq.push(['track', 'Tara Hair Consultation Completed', {
      conversation_history: instance.conversationHistory,
      total_questions: instance.questionCount,
      completed_at: new Date().toISOString()
    }]);

    if (subscribe) {
      _learnq.push(['identify', { '$email': email, '$consent': ['email'] }]);
    }
  }

  window.TaraConsultationAnalytics = Object.freeze({
    track,
    identifyKlaviyo,
  });
})();
